import ThankYouStep from "./ThankYouStep";

export default ThankYouStep;
